import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class RendezvousService {
	constructor(private http: HttpClient) { }

	type(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.rendezvous:contact',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.rendezvous:get',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(
		id: any,
		destinationid: any,
		origineid: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.rendezvous:set',
			params: {
				id: id,
				destinationid: destinationid,
				origineid: origineid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

}
